import { transformToApiPayload } from '../../common/search/useSearchState';

// Search Tags are created by staff in the ops admin and shown as the quick
// filter cards on the search page; the search API filters them as
// `admin_tag_ids`.
export const SEARCH_TAG_IDS = {
  EUROPE: '0157a475-135b-462e-96da-da4342c1b10b',
  THAILAND: '7ab79dbc-94a6-4b65-a559-dd5a5b0419cd',
  WATERCRAFT_TICKET: '392a0025-0ed2-4508-8457-3280d4a05075',
  LAKE_EXCLUSIVE: '10d2c34f-8107-44cc-8a89-edc42a67db71',
  MATCH_LAKES: '060f74cb-864d-4b60-8a46-2cf805797334',
  LODGES: '10a7a430-d2e0-4b2c-8284-1dcb4b5eeeb7',
};

export const INITIAL_FILTERS = {
  is_premium: false,
  is_coming_soon: false,
  has_accommodation_lake: false,
  has_flythrough: false,
  has_virtual_experience: false,
  has_sb_diaries: false,
  has_ratings: false,
  has_comments: false,
  species: [],
  lake_booking_types: [],
  quick_facts: [],
  facilities: [],
  lake_types: [],
  admin_tag_ids: [],
  min_max_weight: null,
  country: null,
};

// Encodes only non-default filter values to keep URL short
export function encodeFiltersForUrl(filters) {
  const diff = {};
  Object.keys(filters).forEach((k) => {
    const v = filters[k];
    const initial = INITIAL_FILTERS[k];
    const isEmptyArray = Array.isArray(v) && v.length === 0;
    const isSame = JSON.stringify(v) === JSON.stringify(initial);
    if (!isSame && !isEmptyArray) {
      diff[k] = v;
    }
  });
  return Object.keys(diff).length
    ? encodeURIComponent(JSON.stringify(diff))
    : null;
}

export function decodeFiltersFromUrl(raw) {
  if (!raw) {
    return INITIAL_FILTERS;
  }
  try {
    return { ...INITIAL_FILTERS, ...JSON.parse(decodeURIComponent(raw)) };
  } catch {
    return INITIAL_FILTERS;
  }
}

export function buildSearchPath({ query, filters = {} } = {}) {
  const params = new URLSearchParams();
  if (query) {
    params.set('query', query);
  }
  const encodedFilters = encodeFiltersForUrl(filters);
  if (encodedFilters) {
    params.set('filters', encodedFilters);
  }
  const search = params.toString();
  return search ? `/search?${search}` : '/search';
}

export function buildSearchTagPath(searchTagId) {
  return buildSearchPath({ filters: { admin_tag_ids: [searchTagId] } });
}

export function buildDateSearchPath(searchState) {
  const params = new URLSearchParams({
    query: JSON.stringify(transformToApiPayload(searchState)),
    searchByDate: 'yes',
  });
  const locationName = searchState.selectedLocation?.address;
  if (locationName) {
    params.set('locationName', locationName);
  }
  return `/search/live-availability?${params}`;
}

export function buildEventSearchPath(query) {
  return `/events/search?${new URLSearchParams({ query })}`;
}
